const TOKEN_MARK = 'prism-token';

export default TOKEN_MARK;
